export const DefaultDebounceTimeoutInMs = 500;
